<span class="ui-text">
  <ng-content></ng-content>
</span>
